export const EQUITY_WITHDRAW_WIZARD_TYPES = {
  DISTRIBUTION: 'distribution',
  TRANSFER: 'transfer',
};
